/* istanbul ignore file */

import { updateDayjsLocale } from '@utilities/dateTime';
updateDayjsLocale();

import '@services/LazyloadService';
import '@core/plugin-loader';
import '@core/stylesheet-loader';
import '@core/react-loader';

import '@services/QualifioTrackingService';
import '@services/GptBannerService';
